<template>
    <div class="search">
        <router-view></router-view>

        <div class="search__floating-card">
            <icon-button class="close-button"
                         @click="closeInfo">
                close
            </icon-button>

            <form class="search-form" autocomplete="off">
                <div class="search-form__top">
                    <div class="search-form__row">
                        <text-field label="Artikelnummer"
                                    v-model="form.artnum"
                                    @keyup.enter.ctrl="search"
                        />
                    </div>

                    <div class="search-form__row">
                        <text-field label="Tags"
                                    v-model="form.tags"
                                    type="textarea"
                                    :rows="3"
                                    :resizable="false"
                                    @keyup.enter.ctrl="search"
                        />
                    </div>
                </div>

                <div class="search-form__middle">
                    <labelled-checkbox v-model="form.foto">
                        mit foto
                    </labelled-checkbox>

                    <select v-model="form.stao">
                        <option value="0" class="search-form__input">
                            - none -
                        </option>
                        <option value="d" class="search-form__input">
                            - diag -
                        </option>
                        <option v-for="option in stao10min"
                                :key="option.id"
                                :value="option.id"
                                class="search-form__input">
                            {{option.name}}
                        </option>
                    </select>
                </div>

                <div class="search-form__bottom" @click.prevent="showTrainsSelect">
                    <div v-show="selectedTrains[0] == null" id="hideDiv" class="hideDiv">
                        <p class="hideText">Züge</p><br>
                    </div>
                    <div v-for="item in selectedTrains"
                         :key="item.id"
                    >
                        {{item.train}}
                    </div>
                </div>

                <div class="search-form__buttons">
                    <div class="search-form__button search-form__button--submit">
                        <default-button @click.prevent="search"
                                        :variations="['full-width']"
                        >
                            Suchen
                        </default-button>
                    </div>

                    <div class="search-form__button">
                        <default-button @click.prevent="reset"
                                        :variations="['danger']"
                        >
                            Zurücksetzen
                        </default-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import DefaultButton from '../common/default-button';
import IconButton from '../common/icon-button';
import { mapGetters } from 'vuex';
import LabelledCheckbox from '../common/labelled-checkbox';
import TextField from '../common/text-field';

export default {
    components: { TextField, LabelledCheckbox, IconButton, DefaultButton },
    data() {
        return {
            form: {
                artnum: '',
                tags: '',
                foto: '',
                stao: ''
            }
        }
    },
    computed: {
        ...mapGetters('fotodatenbank', [
            'selectedTrains',
            'searchItems'
        ]),
        ...mapGetters('user', [
            'stao10min',
            'userStao'
        ])
    },
    methods: {
        closeInfo() {
            this.$router.push('/fotodatenbank');
        },
        search() {
            this.$store.dispatch('fotodatenbank/saveSearchTrains');
            this.$store.dispatch('fotodatenbank/search', { ...this.form });
        },
        showTrainsSelect() {
            this.$router.push({ name: 'trainSelect' });
        },
        reset() {
            this.form.artnum = '';
            this.form.tags = '';
            this.form.foto = false;
            this.form.stao = 0;

            this.$store.commit('fotodatenbank/selectedTrains', []);
        }
    },
    created() {
        this.$store.dispatch('fotodatenbank/trains');
        this.$store.dispatch('fotodatenbank/loadSearchTrains');
    },
    mounted() {
        this.$store.dispatch('user/getStaos10Min');

        this.form.artnum = this.searchItems.artnum;
        this.form.tags = this.searchItems.tags;
        this.form.foto = this.searchItems.foto;
        //this.form.stao = this.searchItems.stao ? this.searchItems.stao : this.userStao;
        this.form.stao = this.searchItems.stao ? this.searchItems.stao : 0;
    }
}
</script>

<style scoped lang="scss">
    .close-button {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
    }

    .search-form__button {
        display: flex;
        flex-direction: row;

        &--submit {
            flex-grow: 1;
            margin-right: 1rem;
        }
    }

    .search {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;

        // @media screen and (min-width: 620px) {
        //     z-index: 0;
        // }

        @include medium {
            z-index:0;
        }

    }

    .search__floating-card {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100vh;
        background-color: $color-white;
        @include default-shadow;
        padding-top: 0.625rem;
        padding-bottom: 0.625rem;

        @include medium {
            width: 31rem;
            height: auto;
        }

        @include extra-large {
            width: 37.5rem;
        }
    }

    .search-form {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        padding-top: 3rem;
        padding-left: 1rem;
        padding-right: 1rem;
    }

    .search-form__top {
        margin-bottom: 1rem;
    }

    .search-form__middle {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 1rem;
    }

    .search-form__bottom {
        flex: 1;
        width: 100%;
        font-size: 1.25rem;
        overflow-y: auto;
        cursor: pointer;
        min-height: 100px;
        margin-bottom: 1rem;
    }

    .search-form__row {
        margin-bottom: 1rem;
    }

    .search-form__buttons {
        display: flex;
    }

    .hideDiv {
        width: 100%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .hideText {
        font-size: 1.25rem;
        color: $color-gray;

        @include extra-large {
            font-size: 2rem;
        }
    }
</style>
